import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import {
  ENVIRONMENT_CONFIG,
  IEnvironmentConfig,
} from '../../../types/IEnvironmentConfig';

@Injectable({ providedIn: 'root' })
export class ApiService {
  baseUrl = this.environment.BASE_URL;

  constructor(
    protected httpClient: HttpClient,
    @Inject(ENVIRONMENT_CONFIG) protected environment: IEnvironmentConfig
  ) {}

  httpOptions = {
    headers: new HttpHeaders({}),
  };

  /**
   * Get Base Url
   * @param uri string
   */
  getBaseUrl(): any {
    return this.baseUrl;
  }

  /**
   * GET request
   */
  get(uri: string): any {
    return this.httpClient
      .get(this.getBaseUrl() + uri)
      .pipe(catchError(this.handleError));
  }

  /**
   * PATCH request
   */
  patch(uri: string, data: any): Observable<any> {
    // this.httpOptions.headers.append(
    //   'Content-Type',
    //   'application/json;charset=UTF-8'
    // );
    return this.httpClient
      .patch(this.getBaseUrl() + uri, data, this.httpOptions)
      .pipe(catchError((err) => this.handleError(err)));
  }

  /**
   * PUT request
   */
  put(uri: string, data: any): Observable<any> {
    // this.httpOptions.headers.append(
    //   'Content-Type',
    //   'application/json;charset=UTF-8'
    // );
    return this.httpClient
      .put(this.getBaseUrl() + uri, data, this.httpOptions)
      .pipe(catchError((err) => this.handleError(err)));
  }

  /**
   * POST request
   */
  post(uri: string, data: any): Observable<any> {
    // this.httpOptions.headers.append('oauth-token', '');
    return this.httpClient
      .post(this.getBaseUrl() + uri, data, this.httpOptions)
      .pipe(catchError((err) => this.handleError(err)));
  }

  /**
   * DELETE request
   */
  delete(uri: string): Observable<any> {
    // this.httpOptions.headers.append('oauth-token', '');
    return this.httpClient
      .delete(this.getBaseUrl() + uri, this.httpOptions)
      .pipe(catchError((err) => this.handleError(err)));
  }

  /**
   * UPLOAD document request
   */
  uploadDocument(uri: string, data: any): Observable<any> {
    // this.httpOptions.headers.append('Content-Type', 'multipart/form-data;');
    return this.httpClient
      .put(this.getBaseUrl() + uri, data, this.httpOptions)
      .pipe(catchError((err) => this.handleError(err)));
  }

  /**
   * Handle general errors from the API
   *
   * @param err
   * @returns {ErrorObservable}
   */
   protected handleError(err: any) {
    return observableThrowError(err);
  }

  protected buildUrl(urlSuffix: string = ''): string {
    urlSuffix = urlSuffix.trim();
    return this.environment.production
      ? `${this.environment.BASE_URL}${urlSuffix}`
      : urlSuffix;
  }
}
